import React from "react";
import { Box } from "../elements/Box";
import { Button } from "../elements/Button";
import { Flex } from "../elements/Flex";
import { Grid } from "../elements/Grid";
import { Heading } from "../elements/Heading";
import { Form } from "../elements/Form";
import { Input } from "../elements/Input";

const FreeGuidesForm = ({ clippedBg }) => {
  return (
    <Flex position="relative" bg="darkTeal">
      <Box
        position="absolute"
        bg={clippedBg || "white"}
        height="100px"
        width="100%"
        top="-1px"
        style={{ clipPath: "polygon(0 0, 100% 0%, 100% 26%, 0 9%)" }}
      />

      <Form
        name="free-guides"
        method="POST"
        data-netlify="true"
        netlify-honeypot="bot-field"
        action="/"
        display="flex"
        width="100%"
        maxWidth="600px"
        mx="auto"
        flexDirection={"column"}
        justifyContent="space-evenly"
        py={6}
        px={3}
      >
        <Heading fontWeight={500} textAlign="center" color="white" mb={3}>
          Join the <br /> #LEANWITHLILLY FAMILIA
        </Heading>
        <input type="hidden" name="form-name" value="free-guides" />
        <input type="hidden" name="bot-field" />
        <Grid display={["block", "block", "grid"]} gridTemplateColumns="1fr 1fr" gridGap={3}>
          {" "}
          <Input variant="signUpForm" whitePlaceholder placeholder="First Name" name="firstName" />
          <Input variant="signUpForm" whitePlaceholder placeholder="Last Name" name="lastName" />
        </Grid>

        <Input variant="signUpForm" whitePlaceholder placeholder="Email" type="email" name="email" />
        <Button type="submit" bg="white" color="teal" width="300px" variant="rounded" mx="auto">
          SIGN UP
        </Button>
      </Form>
    </Flex>
  );
};

export default FreeGuidesForm;
